// IT translations for Surplify.
// Maintained as a per-language file. See ../i18n.js for init logic.

const it = {
  "app.title": "Surplify",
  "nav.home": "Home",
  "nav.search": "Cerca",
  "nav.watchlist": "Lista preferiti",
  "nav.requests": "Le mie richieste",
  "nav.dashboard": "Pannello",
  "nav.admin": "Admin",
  "nav.import": "Importa",
  "nav.login": "Accedi",
  "nav.register": "Registrati",
  "nav.logout": "Esci",
  "nav.groupRequests": "Richieste del sito",
  "groupRequests.title": "Richieste in arrivo al sito",
  "groupRequests.subtitle": "Richieste indirizzate ai siti del tuo gruppo",
  "groupRequests.pending": "in sospeso",
  "groupRequests.filterAll": "Tutti gli stati",
  "groupRequests.empty": "Nessuna richiesta in arrivo",
  "groupRequests.emptyHint": "Attualmente non ci sono richieste indirizzate ai tuoi siti.",
  "groupRequests.site": "Sito destinazione",
  "material.request": "Richiedi materiale",
  "material.addToWatchlist": "Aggiungi ai preferiti",
  "material.removeFromWatchlist": "Rimuovi dai preferiti",
  "status.available": "Disponibile",
  "status.reserved": "Riservato",
  "status.pending": "In attesa",
  "status.approved": "Approvato",
  "status.rejected": "Rifiutato",
  "status.completed": "Completato",
  "status.documentation_missing": "Documenti mancanti",
  "badge.groupOnly": "Solo gruppo",
  "badge.external": "Esterno",
  "badge.slowMoving": "Rotazione lenta",
  "badge.nonMoving": "Senza rotazione",
  "badge.missingDocs": "Documenti mancanti",
  "filter.category": "Categoria",
  "filter.site": "Sito",
  "filter.age": "Anzianità",
  "filter.manufacturer": "Produttore",
  "filter.price": "Prezzo",
  "filter.width": "Larghezza",
  "filter.country": "Paese",
  "filter.allCountries": "Tutti i paesi",
  "common.search": "Cerca materiali...",
  "common.loading": "Caricamento...",
  "common.noResults": "Nessun risultato",
  "common.save": "Salva",
  "common.cancel": "Annulla",
  "common.submit": "Invia",
  "common.delete": "Elimina",
  "common.edit": "Modifica",
  "common.view": "Visualizza",
  "common.close": "Chiudi",
  "common.back": "Indietro",
  "common.saving": "Salvataggio...",
  "common.create": "Crea",
  "home.newListings": "Nuove inserzioni",
  "home.highValue": "Stock di alto valore",
  "home.featured": "Materiali in evidenza",
  "auth.email": "E-mail",
  "auth.password": "Password",
  "auth.name": "Nome completo",
  "auth.loginTitle": "Accedi al tuo account",
  "auth.registerTitle": "Crea un account",
  "auth.noAccount": "Non hai un account?",
  "auth.hasAccount": "Hai già un account?",
  "auth.registrationSuccess": "Registrazione riuscita!",
  "auth.pendingApproval": "Il tuo account è stato creato ed è in attesa di approvazione da parte dell'amministratore.",
  "auth.registerDesc": "Crea un account per iniziare a scambiare materiali",
  "dashboard.totalInventory": "Inventario totale",
  "dashboard.slowMoving": "Rotazione lenta (>180 giorni)",
  "dashboard.nonMoving": "Senza rotazione (>360 giorni)",
  "dashboard.pendingRequests": "Richieste in attesa",
  "dashboard.monthlyTransfers": "Trasferimenti mensili",
  "dashboard.overdueItems": "Articoli scaduti",
  "dashboard.subtitle": "Panoramica globale dell'inventario",
  "dashboard.siteFilter": "Filtra per sito",
  "dashboard.allSites": "Tutti i siti",
  "dashboard.slowMovingDesc": "Materiali di 181-360 giorni",
  "dashboard.nonMovingDesc": "Materiali oltre 360 giorni",
  "dashboard.transfersDesc": "Trasferimenti interni questo mese",
  "dashboard.overdueDesc": "Articoli che richiedono attenzione",
  "dashboard.ageChart": "Inventario per anzianità",
  "dashboard.ageChartDesc": "Distribuzione del valore per anzianità",
  "dashboard.siteRanking": "Classifica dei siti",
  "dashboard.siteRankingDesc": "Siti con più inventario a rotazione lenta",
  "dashboard.overdueTitle": "Articoli scaduti (>360 giorni)",
  "dashboard.overdueDesc2": "Questi articoli richiedono attenzione immediata",
  "dashboard.viewAllOverdue": "Vedi tutti i {{count}} articoli scaduti",
  "dashboard.viewNonMoving": "Vedi stock senza rotazione",
  "dashboard.pendingRequestsLink": "Richieste in attesa",
  "dashboard.importMaterials": "Importa materiali",
  "dashboard.age0_90": "0-90 giorni",
  "dashboard.age91_180": "91-180 giorni",
  "dashboard.age181_360": "181-360 giorni",
  "dashboard.ageGt360": ">360 giorni",
  "dashboard.slowMovingItems": "Articoli a rotazione lenta",
  "dashboard.totalMaterials": "Totale materiali",
  "dashboard.totalMaterialsDesc": "Materiali attivi in inventario",
  "dashboard.externalSales": "Vendite esterne",
  "dashboard.externalSalesDesc": "Vendite esterne questo mese",
  "dashboard.sitePending": "Richieste in attesa",
  "dashboard.sitePendingDesc": "Richieste in attesa per questo sito",
  "import.title": "Importa materiali",
  "import.subtitle": "Importa ed esporta dati materiali tramite Excel",
  "import.downloadTemplate": "Scarica modello",
  "import.uploadFile": "Carica file",
  "import.validate": "Valida",
  "import.execute": "Esegui importazione",
  "import.mode.overwrite": "Sovrascrivi tutto",
  "import.mode.enrich": "Solo arricchire",
  "import.mode.selective": "Seleziona campi",
  "import.export": "Esporta",
  "import.exportTitle": "Esporta materiali",
  "import.exportDesc": "Scarica dati materiali come file Excel con filtri",
  "import.exportDownload": "Scarica Excel",
  "request.title": "Richiedi materiale",
  "request.quantity": "Quantità",
  "request.message": "Messaggio (opzionale)",
  "request.type.internal": "Trasferimento interno",
  "request.type.external": "Richiesta esterna",
  "requests.tab.my": "Le mie richieste",
  "requests.tab.incoming": "Richieste in arrivo",
  "requests.details": "Dettagli della richiesta",
  "requests.detail.article": "Articolo",
  "requests.detail.quantity": "Quantità richiesta",
  "requests.detail.type": "Tipo",
  "requests.detail.requestedBy": "Richiesto da",
  "requests.detail.date": "Data",
  "requests.detail.message": "Messaggio",
  "requests.from": "Da",
  "requests.viewDetails": "Vedi dettagli",
  "requests.loginRequired": "Accesso richiesto",
  "requests.loginHint": "Accedi per visualizzare le tue richieste",
  "requests.empty.my": "Nessuna richiesta inviata",
  "requests.empty.myHint": "Non hai ancora fatto richieste. Esplora i materiali!",
  "requests.empty.incoming": "Nessuna richiesta in arrivo",
  "requests.empty.incomingHint": "Non hai richieste in arrivo per i tuoi materiali.",
  "requests.action.approve": "Approva",
  "requests.action.reject": "Rifiuta",
  "requests.action.complete": "Completa",
  "requests.action.approveTitle": "Approva richiesta",
  "requests.action.rejectTitle": "Rifiuta richiesta",
  "requests.action.completeTitle": "Completa richiesta",
  "requests.action.approveDesc": "Questo approverà la richiesta e riserverà il materiale.",
  "requests.action.rejectDesc": "Questo rifiuterà la richiesta.",
  "requests.action.completeDesc": "Questo completerà il trasferimento e aggiornerà l'inventario.",
  "requests.action.approvedSuccess": "Richiesta approvata",
  "requests.action.rejectedSuccess": "Richiesta rifiutata",
  "requests.action.completedSuccess": "Richiesta completata - inventario aggiornato",
  "requests.action.failed": "Errore nell'aggiornamento della richiesta",
  "restricted.title": "Contenuto limitato",
  "restricted.loginHint": "Accedi per visualizzare prezzi, quantità e dettagli sulla posizione.",
  "restricted.approvalHint": "Il tuo account è in attesa di approvazione.",
  "restricted.cardHint": "Accedi e ottieni l'approvazione per vedere i dettagli",
  "admin.users": "Utenti",
  "admin.usersDesc": "Gestisci registrazioni e approvazioni utenti",
  "admin.noUsers": "Nessun utente trovato",
  "admin.approved": "Approvato",
  "admin.pending": "In attesa",
  "admin.registeredAt": "Registrato",
  "admin.approveUser": "Approva",
  "admin.revokeUser": "Revoca",
  "admin.userApproved": "Utente approvato con successo",
  "admin.userRevoked": "Accesso utente revocato",
  "admin.userApproveFailed": "Errore nell'aggiornamento dello stato",
  "admin.deleteUser": "Elimina utente",
  "admin.deleteUserTitle": "Elimina utente",
  "admin.deleteUserConfirm": "Sei sicuro di voler eliminare permanentemente l'utente {{name}} ({{email}})? Questa azione non può essere annullata.",
  "admin.userDeleted": "Utente eliminato con successo",
  "admin.userDeleteFailed": "Errore nell'eliminazione dell'utente",
  "admin.categoryTree": "Albero delle categorie",
  "admin.categoryTreeDesc": "Gestisci le categorie dei prodotti e la loro gerarchia",
  "admin.addCategory": "Aggiungi categoria",
  "admin.editCategory": "Modifica categoria",
  "admin.deleteCategory": "Elimina categoria",
  "admin.addCategoryDesc": "Crea una nuova categoria di prodotto",
  "admin.editCategoryDesc": "Modifica nome, categoria padre o ordine",
  "admin.deleteCategoryConfirm": "Sei sicuro di voler eliminare \"{{name}}\"?",
  "admin.categoryName": "Nome categoria",
  "admin.categoryNamePlaceholder": "es. Film e pellicole",
  "admin.parentCategory": "Categoria padre",
  "admin.noParent": "Nessuna (livello radice)",
  "admin.sortOrder": "Ordine di visualizzazione",
  "admin.categoryCreated": "Categoria creata",
  "admin.categoryUpdated": "Categoria aggiornata",
  "admin.categoryDeleted": "Categoria disattivata",
  "admin.categoryCreateFailed": "Errore nella creazione della categoria",
  "admin.categoryUpdateFailed": "Errore nell'aggiornamento della categoria",
  "admin.categoryDeleteFailed": "Errore nell'eliminazione della categoria",
  "admin.noCategoriesFound": "Nessuna categoria trovata.",
  "admin.delete": "Elimina",
  "create.newTitle": "Pubblica materiale",
  "create.editTitle": "Modifica materiale",
  "create.materialInfo": "Informazioni sul materiale",
  "create.title": "Titolo",
  "create.titlePlaceholder": "es. Film PE 500mm trasparente",
  "create.description": "Descrizione",
  "create.descPlaceholder": "Descrizione dettagliata del materiale...",
  "create.selectCategory": "Seleziona categoria",
  "create.companyGroup": "Gruppo aziendale",
  "create.selectGroup": "Seleziona gruppo",
  "create.partNumber": "Numero di parte",
  "create.thickness": "Spessore",
  "create.grade": "Grado del materiale",
  "create.coreDiameter": "Diametro del nucleo",
  "create.skuInfo": "Dati di magazzino (SKU)",
  "create.addSku": "Aggiungi stock",
  "create.addMore": "Aggiungi SKU",
  "create.selectSite": "Seleziona sito",
  "create.articleNumber": "Numero articolo",
  "create.rolls": "Numero di rotoli",
  "create.bookValue": "Valore contabile",
  "create.listPrice": "Prezzo di listino",
  "create.productionDate": "Data di produzione",
  "create.customerSpecific": "Specifico per il cliente",
  "create.compliant": "Conforme",
  "create.notesInternal": "Note interne",
  "create.notesInternalPlaceholder": "Visibile solo internamente...",
  "create.publish": "Pubblica",
  "create.materialCreated": "Materiale creato con successo",
  "create.materialUpdated": "Materiale aggiornato con successo",
  "create.existingSkus": "Stock esistente",
  "create.noNewSkus": "Nessun nuovo stock aggiunto",
  "create.previewHint": "Anteprima del materiale",
  "create.untitled": "Materiale senza titolo",
  "create.titleRequired": "Il titolo è obbligatorio",
  "create.categoryRequired": "La categoria è obbligatoria",
  "create.manufacturerRequired": "Il produttore è obbligatorio",
  "create.partNumberRequired": "Il numero di parte è obbligatorio",
  "create.groupRequired": "Il gruppo aziendale è obbligatorio",
  "create.siteRequired": "Il sito è obbligatorio",
  "create.articleRequired": "Il numero articolo è obbligatorio",
  "create.quantityRequired": "La quantità è obbligatoria",
  "create.saveError": "Errore durante il salvataggio",
  "watchlist.loginRequired": "Accesso richiesto",
  "watchlist.loginHint": "Accedi per visualizzare i tuoi preferiti",
  "watchlist.empty": "La tua lista preferiti è vuota",
  "watchlist.emptyHint": "Esplora i materiali e clicca sull'icona cuore",
  "watchlist.browse": "Esplora materiali",
  "watchlist.remove": "Rimuovi",
  "watchlist.priceOnRequest": "Prezzo su richiesta",
  "watchlist.addedOn": "Aggiunto il",
  "watchlist.itemCount": "{{count}} articoli nella tua lista",
  "sustainability.title": "Impatto sulla sostenibilità",
  "sustainability.subtitle": "Riduzione dei rifiuti attraverso redistribuzione intelligente",
  "sustainability.heroTagline": "Economia circolare per l'imballaggio",
  "sustainability.heroDesc": "Ogni materiale redistribuito è uno in meno prodotto da zero. Insieme riduciamo la CO2, risparmiamo risorse e costruiamo un ecosistema manifatturiero circolare.",
  "sustainability.co2Saved": "CO2 risparmiata",
  "sustainability.co2SavedDesc": "Emissioni evitate stimate",
  "sustainability.materialsRedistributed": "Materiali redistribuiti",
  "sustainability.materialsRedistributedDesc": "Trasferiti con successo tra i siti",
  "sustainability.valueSaved": "Valore preservato",
  "sustainability.valueSavedDesc": "Capitale circolante risparmiato",
  "sustainability.activeSites": "Siti attivi",
  "sustainability.activeSitesDesc": "Siti che partecipano alla redistribuzione",
  "sustainability.circularRate": "Tasso economia circolare",
  "sustainability.circularRateDesc": "Materiali con una seconda vita",
  "sustainability.atRisk": "Materiali a rischio",
  "sustainability.atRiskDesc": "Stock a rotazione lenta/nulla redistribuibile",
  "sustainability.pendingRedist": "Redistribuzioni in corso",
  "sustainability.pendingRedistDesc": "Trasferimenti in fase di elaborazione",
  "sustainability.availableForReuse": "Disponibile per il riutilizzo",
  "sustainability.impactBanner": "Insieme preveniamo i rifiuti di imballaggio e risparmiamo risorse",
  "sustainability.kgUnit": "kg",
  "sustainability.tonUnit": "t",
  "sustainability.downloadReport": "Scarica rapporto ESG",
  "sustainability.downloadReportDesc": "Genera un rapporto PDF di sostenibilità",
  "sustainability.reportGenerating": "Generazione del rapporto...",
  "sustainability.reportReady": "Rapporto ESG scaricato con successo",
  "sustainability.reportError": "Errore nella generazione del rapporto",
  "footer.tagline": "Mercato governato per materiali di imballaggio in eccedenza.",
  "footer.marketplace": "Mercato",
  "footer.forPartners": "Per i partner",
  "footer.support": "Supporto",
  "footer.legalTitle": "Legale",
  "footer.agb": "Condizioni generali",
  "footer.impressum": "Note legali",
  "footer.datenschutz": "Informativa sulla privacy",
  "footer.datenschutzeinstellungen": "Impostazioni privacy",
  "footer.rights": "Tutti i diritti riservati.",
  "nav.standardMaterials": "Materiali standard",
  "nav.transactions": "Transazioni",
  "nav.matching": "Material Matching",
  "nav.analytics": "Analisi",
  "nav.language": "Lingua",
  "nav.switchGroup": "Cambia gruppo",
  "matching.title": "Material Matching",
  "matching.subtitle": "Corrispondenza automatica delle eccedenze con la domanda di altri siti",
  "matching.refresh": "Aggiorna",
  "matching.matches": "Corrispondenze",
  "matching.matchRate": "Tasso di corrispondenza",
  "matching.potSavings": "Risp. pot.",
  "matching.sites": "Siti",
  "matching.surplusAvailable": "{{count}} eccedenze disponibili",
  "matching.demandPositions": "{{count}} posizioni di domanda",
  "matching.matchedQuantity": "{{count}} kg quantità corrispondente",
  "matching.providers": "{{count}} fornitori",
  "matching.consumers": "{{count}} richiedenti",
  "matching.topMaterials": "Materiali più corrispondenti",
  "matching.offerSite": "Sito fornitore",
  "matching.demandSite": "Sito richiedente",
  "matching.manufacturer": "Produttore",
  "matching.searchManufacturer": "Cerca produttore...",
  "matching.allSites": "Tutti i siti",
  "matching.noMatches": "Nessuna corrispondenza",
  "matching.noMatchesDesc": "Non sono state trovate corrispondenze tra eccedenze e liste di domanda.",
  "matching.matchesFound": "{{count}} corrispondenza/e trovata/e",
  "matching.material": "Materiale",
  "matching.provider": "Fornitore",
  "matching.consumer": "Richiedente",
  "matching.quantity": "Quantità",
  "matching.bookValue": "Valore contabile",
  "matching.age": "Anzianità",
  "matching.width": "Larghezza",
  "matching.widthFit": "Conforme",
  "matching.widthDeviation": "Scart.",
  "matching.action": "Azione",
  "matching.view": "Vedi",
  "matching.age0_90": "0–90 giorni",
  "matching.age91_180": "91–180 giorni",
  "matching.age181_360": "181–360 giorni",
  "matching.ageGt360": "> 360 giorni",
  "analytics.title": "Analisi e report",
  "analytics.subtitle": "Analisi delle tendenze, prestazioni dei siti e valutazioni delle corrispondenze",
  "analytics.tabTrends": "Tendenze",
  "analytics.tabSites": "Siti",
  "analytics.tabMatching": "Matching",
  "analytics.last6Months": "Ultimi 6 mesi",
  "analytics.last12Months": "Ultimi 12 mesi",
  "analytics.last24Months": "Ultimi 24 mesi",
  "analytics.inventoryTrend": "Evoluzione dell'inventario",
  "analytics.inventoryTrendDesc": "Sviluppo mensile del numero di articoli e del valore dell'inventario",
  "analytics.articles": "Articoli",
  "analytics.valueKEUR": "Valore (kEUR)",
  "analytics.transactionVolume": "Volume delle transazioni",
  "analytics.transactionVolumeDesc": "Transazioni mensili",
  "analytics.transactions": "Transazioni",
  "analytics.requestTrend": "Evoluzione delle richieste",
  "analytics.requestTrendDesc": "Totale vs. richieste completate",
  "analytics.requests": "Richieste",
  "analytics.completed": "Completate",
  "analytics.siteComparison": "Confronto siti: valore dell'inventario",
  "analytics.siteComparisonDesc": "Valore totale (kEUR) per sito",
  "analytics.redistributionRanking": "Classifica redistribuzione",
  "analytics.redistributionRankingDesc": "Redistribuzioni completate per sito",
  "analytics.redistributions": "Redistribuzioni",
  "analytics.openRequests": "Richieste aperte",
  "analytics.siteDetails": "Dettagli del sito",
  "analytics.site": "Sito",
  "analytics.value": "Valore (kEUR)",
  "analytics.slowMoving": "Rotazione lenta",
  "analytics.redistributed": "Redistribuito",
  "analytics.demand": "Domanda",
  "analytics.noSiteData": "Nessun dato disponibile per i siti",
  "analytics.kpiMatches": "Corrispondenze",
  "analytics.kpiMatchRate": "Tasso di corrispondenza",
  "analytics.kpiMatchedValue": "Valore corrispondente",
  "analytics.kpiMaterials": "Materiali",
  "analytics.topMatchedMaterials": "Materiali più corrispondenti",
  "analytics.categoryDistribution": "Corrispondenze per categoria",
  "analytics.sitePairFlows": "Flussi di siti (Fornitore → Richiedente)",
  "analytics.sitePairFlowsDesc": "Flussi di materiale più frequenti tra i siti",
  "analytics.noData": "Nessun dato",
  "analytics.noMatchingData": "Nessun dato di corrispondenza disponibile",
  "transactions.title": "Transazioni",
  "transactions.subtitle": "Tutte le transazioni completate e aperte",
  "transactions.allStatuses": "Tutti gli stati",
  "transactions.statusCompleted": "Completata",
  "transactions.statusCancelled": "Annullata",
  "transactions.statusPending": "Aperta",
  "transactions.total": "Transazioni",
  "transactions.completed": "Completate",
  "transactions.totalValue": "Valore totale",
  "transactions.date": "Data",
  "transactions.material": "Materiale",
  "transactions.type": "Tipo",
  "transactions.seller": "Venditore",
  "transactions.buyer": "Acquirente",
  "transactions.quantity": "Quantità",
  "transactions.value": "Valore",
  "transactions.fee": "Commissione",
  "transactions.status": "Stato",
  "transactions.rating": "Valutazione",
  "transactions.internal": "Interno",
  "transactions.external": "Esterno",
  "transactions.empty": "Nessuna transazione ancora",
  "transactions.emptyDesc": "Le transazioni vengono create automaticamente al completamento delle richieste.",
  "transactions.rate": "Valuta",
  "transactions.rated": "Valutato",
  "transactions.rateTitle": "Valuta la transazione",
  "transactions.counterparty": "Controparte",
  "transactions.unknown": "Sconosciuto",
  "transactions.commentLabel": "Commento (opzionale)",
  "transactions.commentPlaceholder": "Come è stata la cooperazione?",
  "transactions.submitRating": "Invia valutazione",
  "transactions.submitting": "Invio in corso...",
  "transactions.ratingSuccess": "Valutazione inviata",
  "transactions.ratingError": "Errore nell'invio della valutazione",
  "transactions.ratingRequired": "Valuta almeno una categoria",
  "transactions.loadError": "Errore nel caricamento delle transazioni",
  "transactions.reviews": "Valutazioni",
  "transactions.noReviews": "Nessuna valutazione ancora.",
  "transactions.comments": "Commenti",
  "transactions.group": "Gruppo",
  "transactions.review": "valutazioni",
  "notifications.title": "Notifiche",
  "notifications.allRead": "Tutte lette",
  "notifications.none": "Nessuna notifica",
  "notifications.noFiltered": "Nessuna notifica corrispondente",
  "notifications.filterAll": "Tutte",
  "notifications.filterMatches": "Corrispondenze",
  "notifications.filterOther": "Altre",
  "notifications.newMatch": "{{count}} nuova corrispondenza di materiale",
  "notifications.newMatches": "{{count}} nuove corrispondenze di materiale",
  "notifications.goToDashboard": "Vai al pannello",
  "notifications.matchDashboard": "Mostra pannello Material Matching",
  "notifications.justNow": "proprio ora",
  "notifications.minutesAgo": "{{count}} min fa",
  "notifications.hoursAgo": "{{count}} ore fa",
  "notifications.daysAgo": "{{count}} g fa",
  "notifications.site": "Sito",
  "notifications.typeMatch": "Corrispondenza",
  "notifications.typeApproval": "Corrispondenza approvazione",
  "notifications.typeRequest": "Richiesta",
  "notifications.typeEscalation": "Escalation",
  "notifications.typeLogistics": "Logistica",
  "notifications.typeInfo": "Info",
  "partners.heroTitle": "Acquistare. Vendere. Riutilizzare. Materiali in eccesso — in modo più intelligente.",
  "partners.heroSubtitle": "Unisciti al principale marketplace per gli eccessi di materiali di imballaggio. Accedi a materiali verificati dai migliori produttori.",
  "partners.ctaRegister": "Registrati come partner",
  "partners.ctaBrowse": "Esplora materiali",
  "partners.trust1": "Registrazione gratuita",
  "partners.trust2": "Fornitori verificati",
  "partners.trust3": "Nessun impegno",
  "partners.howItWorksLabel": "Processo",
  "partners.howItWorksTitle": "Come funziona",
  "partners.howItWorksSubtitle": "Tre semplici passaggi per iniziare a risparmiare.",
  "partners.step1Title": "Registrarsi",
  "partners.step1Desc": "Crea il tuo account aziendale in pochi minuti.",
  "partners.step2Title": "Esplorare",
  "partners.step2Desc": "Cerca migliaia di materiali in eccesso verificati.",
  "partners.step3Title": "Richiedere",
  "partners.step3Desc": "Invia una richiesta direttamente al fornitore.",
  "partners.benefitsTitle": "Perché scegliere Surplify",
  "partners.benefit1Title": "Risparmia fino al 40%",
  "partners.benefit1Desc": "Accedi a materiali in eccesso a una frazione del costo originale.",
  "partners.benefit2Title": "Qualità verificata",
  "partners.benefit2Desc": "Ogni annuncio include dati del produttore e report sulle condizioni.",
  "partners.benefit3Title": "Impatto ESG",
  "partners.benefit3Desc": "Ogni acquisto riduce le emissioni di CO2.",
  "partners.trustTitle": "Affidato dai leader del settore",
  "partners.trustSubtitle": "Aziende in tutta Europa si affidano a Surplify",
  "partners.trustUsers": "50+ aziende",
  "partners.trustStat1": "40%",
  "partners.trustStat1Label": "Risparmio medio sui costi",
  "partners.trustStat2": "500+",
  "partners.trustStat2Label": "Annunci verificati",
  "partners.trustStat3": "50+",
  "partners.trustStat3Label": "Aziende partner attive",
  "partners.ctaFinalTitle": "Pronto a risparmiare?",
  "partners.ctaFinalDesc": "Unisciti a centinaia di aziende che usano già Surplify.",
  "partners.ctaFinalRegister": "Inizia gratuitamente",
  "partners.noCredit": "Nessuna carta di credito richiesta.",
  "demo.badge": "Prenota una demo",
  "demo.ctaHero": "Prenota una demo",
  "demo.title": "Scopri Surplify in azione",
  "demo.subtitle": "Prenota una demo gratuita e personalizzata con il nostro team.",
  "demo.point1": "Tour dal vivo della piattaforma",
  "demo.point2": "Su misura per il tuo settore",
  "demo.point3": "Senza impegno — completamente gratuito",
  "demo.name": "Nome",
  "demo.namePlaceholder": "Il tuo nome completo",
  "demo.email": "Email aziendale",
  "demo.emailPlaceholder": "nome@azienda.it",
  "demo.company": "Azienda",
  "demo.companyPlaceholder": "Nome della tua azienda",
  "demo.phone": "Telefono (opzionale)",
  "demo.phonePlaceholder": "+39 ...",
  "demo.message": "Messaggio (opzionale)",
  "demo.messagePlaceholder": "Raccontaci le tue esigenze...",
  "demo.submit": "Richiedi demo",
  "demo.sending": "Invio in corso...",
  "demo.privacy": "Rispettiamo la tua privacy. I tuoi dati saranno usati solo per contattarti riguardo la tua richiesta.",
  "demo.requiredFields": "Compila tutti i campi obbligatori.",
  "demo.successToast": "Richiesta demo inviata con successo!",
  "demo.errorToast": "Invio fallito. Riprova.",
  "demo.successTitle": "Grazie!",
  "demo.successDesc": "La tua richiesta è stata ricevuta. Il nostro team ti contatterà entro 24 ore.",
  "onboarding.step": "Passo",
  "onboarding.of": "di",
  "onboarding.skip": "Salta per ora",
  "onboarding.next": "Avanti",
  "onboarding.finish": "Inizia",
  "onboarding.restartTour": "Riavvia il tour",
  "onboarding.step1Title": "Benvenuto su Surplify",
  "onboarding.step1Desc": "Surplify è il principale marketplace per gli eccessi di materiali di imballaggio.",
  "onboarding.step1Points": ["Migliaia di materiali verificati", "Risparmia fino al 40%", "Tracciamento ESG automatico"],
  "onboarding.step2Title": "Il tuo profilo aziendale",
  "onboarding.step2Desc": "Il tuo profilo rappresenta la tua azienda sulla piattaforma.",
  "onboarding.step2Points": ["Aggiungi logo e descrizione", "Verifica i tuoi dati di contatto", "Imposta le preferenze"],
  "onboarding.step3Title": "Trovare materiali",
  "onboarding.step3Desc": "Usa la ricerca avanzata per trovare esattamente ciò di cui hai bisogno.",
  "onboarding.step3Points": ["Cerca per produttore o numero articolo", "Filtra per categoria e paese", "Salva nella lista osservata"],
  "onboarding.step4Title": "Richiedere materiali",
  "onboarding.step4Desc": "Invia una richiesta direttamente al fornitore.",
  "onboarding.step4Points": ["Indica la quantità richiesta", "Aggiungi un messaggio", "Segui lo stato in tempo reale"],
  "admin.addCompany": "Aggiungi azienda",
  "admin.addGroup": "Aggiungi gruppo",
  "admin.addSite": "Aggiungi sito",
  "admin.approvalRequired": "Approvazione richiesta",
  "admin.approvalRequiredDesc": "Richiede l'approvazione del responsabile per le richieste",
  "admin.approve": "Approva",
  "admin.approveCompany": "Approva",
  "admin.auditAction": "Azione",
  "admin.auditAll": "Tutti",
  "admin.auditChanges": "Modifiche",
  "admin.auditEntity": "Entita",
  "admin.auditFilterAction": "Filtra per azione",
  "admin.auditFilterEntity": "Filtra per entita",
  "admin.auditLog": "Registro di audit",
  "admin.auditLogDesc": "Cronologia completa di tutte le modifiche del sistema",
  "admin.auditNextPage": "Successivo",
  "admin.auditNoEntries": "Nessuna voce di audit trovata.",
  "admin.auditPage": "Pagina {{page}} di {{pages}}",
  "admin.auditPrevPage": "Precedente",
  "admin.auditTimestamp": "Data e ora",
  "admin.auditUser": "Utente",
  "admin.autoApproval": "Approvazione automatica",
  "admin.categories": "Categorie",
  "admin.city": "Citta",
  "admin.companyApproved": "Azienda approvata",
  "admin.companyCreated": "Azienda creata con successo",
  "admin.companyFailed": "Errore nell'aggiornamento dell'azienda",
  "admin.companyName": "Nome azienda",
  "admin.companyNamePlaceholder": "es. PackPro GmbH",
  "admin.companyRejected": "Azienda rifiutata",
  "admin.contactEmail": "E-mail di contatto",
  "admin.contactName": "Nome del contatto",
  "admin.contactPhone": "Telefono di contatto",
  "admin.country": "Paese",
  "admin.defaultImage": "Immagine predefinita",
  "admin.docsBlocked": "Docs bloccati",
  "admin.domainsAllowed": "Domini consentiti",
  "admin.emailsFailed": "E-mail fallite",
  "admin.emailsSent": "E-mail inviate",
  "admin.emailsSkipped": "Saltate",
  "admin.escalatedRequests": "Richieste escalate",
  "admin.escalationDays": "Giorni di escalation",
  "admin.escalationDaysDesc": "Giorni prima delle notifiche di escalation",
  "admin.externalBlocked": "Esterno bloccato",
  "admin.externalCompanies": "Aziende esterne",
  "admin.externalCompaniesDesc": "Gestisci registrazioni e approvazioni di aziende esterne",
  "admin.externalEnabled": "Pubblicazione esterna abilitata",
  "admin.externalEnabledDesc": "Consenti ai materiali di essere visibili esternamente",
  "admin.externalOpen": "Esterno aperto",
  "admin.groupAdmin": "Admin di gruppo",
  "admin.groupAdminDesc": "Gestisci strategia e utenti del tuo gruppo aziendale",
  "admin.groupName": "Nome del gruppo",
  "admin.groupNamePlaceholder": "es. Acme Packaging Group",
  "admin.groupUsersDesc": "Gestisci e approva gli utenti del tuo gruppo aziendale",
  "admin.guide": "Guida",
  "admin.guideAudit": "Registro di audit",
  "admin.guideAuditText": "Il registro di audit fornisce una cronologia completa di tutte le modifiche del sistema per conformita e tracciabilita.",
  "admin.guideAuditTip": "Il registro di audit e immutabile e non puo essere modificato o eliminato.",
  "admin.guideCategories": "Gestione categorie",
  "admin.guideCategoriesText": "Le categorie organizzano i materiali in una struttura ad albero gerarchica.",
  "admin.guideCategoriesTip": "Le categorie eliminate vengono disattivate (cancellazione soft). I materiali precedentemente assegnati restano accessibili.",
  "admin.guideDashboard": "Dashboard e Reporting",
  "admin.guideDashboardText": "La Dashboard fornisce KPI in tempo reale su eta dell'inventario, attivita di trasferimento, metriche di sostenibilita e valore a rischio.",
  "admin.guideDashboardTip": "Il report di sostenibilita include stime di risparmio di CO2 basate sulle quantita di materiali redistribuiti.",
  "admin.guideDesc": "Guida completa per la configurazione della piattaforma, governance e gestione quotidiana",
  "admin.guideExternal": "Aziende esterne",
  "admin.guideExternalText": "Le aziende esterne possono autoregistrarsi sulla piattaforma. Gli amministratori esaminano le richieste e le approvano o rifiutano.",
  "admin.guideExternalTip": "All'approvazione o al rifiuto, viene inviata automaticamente una notifica via e-mail al contatto dell'azienda.",
  "admin.guideGettingStarted": "Per iniziare",
  "admin.guideGettingStartedText": "Benvenuto in Surplify! Questa piattaforma aiuta la tua organizzazione a ridurre il capitale circolante redistribuendo le materie prime a rotazione lenta tra i siti.",
  "admin.guideGettingStartedTip": "Usa il pulsante 'Carica dati di esempio' per popolare categorie e materiali di demo.",
  "admin.guideImport": "Import/Export Excel",
  "admin.guideImportText": "La pagina di importazione supporta la gestione in massa dei materiali tramite caricamento di file Excel.",
  "admin.guideImportTip": "Usa la modalita 'Solo arricchimento' per aggiornamenti incrementali senza sovrascrivere i dati esistenti.",
  "admin.guideNotifications": "Notifiche via e-mail",
  "admin.guideNotificationsText": "La piattaforma invia notifiche automatiche via e-mail per richieste escalate, nuove richieste di materiali e cambiamenti di stato delle aziende esterne.",
  "admin.guideNotificationsTip": "Le e-mail di escalation vengono attivate quando le richieste in attesa superano la soglia 'Giorni di escalation' configurata.",
  "admin.guideScenarios": "Configurazione scenari",
  "admin.guideScenariosText": "Gli scenari controllano le regole di governance per la redistribuzione dei materiali.",
  "admin.guideScenariosTip": "La dashboard dell'impatto dello scenario mostra gli effetti in tempo reale delle impostazioni attuali.",
  "admin.guideTitle": "Guida all'amministrazione",
  "admin.guideVotes.title": "Sezioni della guida con la valutazione piu bassa",
  "admin.guideVotes.desc": "Le 5 sezioni con il feedback piu negativo degli utenti - da rivedere.",
  "admin.guideVotes.empty": "Ancora nessuna valutazione.",
  "admin.guideVotes.loading": "Caricamento delle valutazioni…",
  "admin.guideVotes.unknownSection": "Sezione sconosciuta",
  "admin.guideVotes.score": "Punteggio netto (pollice su − giu)",
  "admin.guideUsers": "Gestione utenti",
  "admin.guideUsersText": "Gli utenti si registrano tramite la piattaforma e devono essere approvati prima di accedere ai dati sensibili.",
  "admin.guideUsersTip": "Revocare un utente non elimina il suo account. Puo essere ri-approvato in qualsiasi momento.",
  "admin.houseNumber": "Numero civico",
  "admin.industry": "Settore",
  "admin.internalWindow": "Finestra interna (giorni)",
  "admin.internalWindowDesc": "Giorni in cui gli articoli sono visibili solo internamente",
  "admin.internalWindowItems": "Nella finestra interna",
  "admin.lastCheck": "Ultima verifica",
  "admin.legalPageContent": "Contenuto della pagina (HTML)",
  "admin.legalPageTitle": "Titolo della pagina",
  "admin.legalPages": "Pagine legali",
  "admin.legalPagesDesc": "Modifica pagine di supporto, termini, note legali, privacy",
  "admin.legalPreview": "Anteprima",
  "admin.loadSettings": "Carica impostazioni",
  "admin.manualApproval": "Approvazione manuale",
  "admin.masterData": "Dati anagrafici",
  "admin.materialApprovals": "Approvazioni materiali",
  "admin.materialApprovalsDesc": "Esamina e approva gli elenchi di materiali esterni",
  "admin.mode.aggressive_cash": "Aggressivo (Cash)",
  "admin.mode.aggressive_cashDesc": "Finestre piu brevi, liquidazione piu rapida",
  "admin.mode.balanced": "Equilibrato",
  "admin.mode.balancedDesc": "Regole di governance standard",
  "admin.mode.conservative": "Conservativo",
  "admin.mode.conservativeDesc": "Finestre piu lunghe, piu approvazioni",
  "admin.mode.crisis_mode": "Modalita crisi",
  "admin.mode.crisis_modeDesc": "Modalita di smaltimento d'emergenza",
  "admin.ndaNotSigned": "NDA in attesa",
  "admin.ndaSigned": "NDA firmato",
  "admin.noCompanies": "Nessuna azienda esterna registrata.",
  "admin.noGroups": "Nessun gruppo trovato. Aggiungi il tuo primo gruppo.",
  "admin.noNotifications": "Nessuna notifica inviata",
  "admin.noPendingMaterials": "Nessuna approvazione materiale in attesa",
  "admin.noSites": "Nessun sito trovato. Aggiungi la tua prima sede.",
  "admin.noSitesNoGroup": "Crea prima un gruppo aziendale prima di aggiungere siti.",
  "admin.notifDaysPending": "Giorni in attesa",
  "admin.notifExtApproved": "Approvato",
  "admin.notifExtCompany": "Azienda esterna",
  "admin.notifExtRejected": "Rifiutato",
  "admin.notifMaterial": "Materiale",
  "admin.notifOwner": "Proprietario",
  "admin.notifRecipients": "Destinatari",
  "admin.notifRequestedQty": "Quantita richiesta",
  "admin.notifRequester": "Richiedente",
  "admin.notifSentAt": "Inviato il",
  "admin.notifSite": "Sito",
  "admin.notifStatus": "Stato",
  "admin.notifTypeEscalation": "Escalation",
  "admin.notifTypeExtCompany": "Az. esterne",
  "admin.notifTypeNewRequest": "Nuova richiesta",
  "admin.notifications": "Notifiche",
  "admin.notificationsDesc": "Cronologia e-mail di escalation e gestione",
  "admin.notificationsTitle": "Notifiche via e-mail",
  "admin.orgDesc": "Gestisci le organizzazioni tenant",
  "admin.orgTitle": "Gruppi aziendali",
  "admin.organizations": "Organizzazioni",
  "admin.platformAdminDesc": "Amministrazione piattaforma - gestisci tutti i gruppi, siti e utenti",
  "admin.postalCode": "CAP",
  "admin.reject": "Rifiuta",
  "admin.rejectCompany": "Rifiuta",
  "admin.saveSettings": "Salva impostazioni",
  "admin.scenarioImpact": "Impatto dello scenario",
  "admin.scenarioImpactDesc": "Impatto in tempo reale delle impostazioni attuali",
  "admin.scenarioMode": "Modalita scenario",
  "admin.scenarios": "Scenari",
  "admin.scenariosDesc": "Configura regole di governance e flussi di approvazione",
  "admin.scenariosTitle": "Configurazione scenari",
  "admin.seedData": "Carica dati di esempio",
  "admin.selectGroup": "Seleziona gruppo aziendale",
  "admin.selectGroupPlaceholder": "Scegli un gruppo...",
  "admin.settingsFailed": "Errore nel salvataggio delle impostazioni",
  "admin.settingsSaved": "Impostazioni salvate con successo",
  "admin.sites": "Siti",
  "admin.sitesDesc": "Gestisci le sedi di magazzino",
  "admin.sitesTitle": "Siti",
  "admin.street": "Via",
  "admin.strictDocs": "Documentazione rigorosa",
  "admin.strictDocsActive": "Documentazione rigorosa attiva",
  "admin.strictDocsDesc": "Blocca le importazioni senza schede tecniche",
  "admin.submittedBy": "Inviato da",
  "admin.title": "Amministrazione",
  "admin.totalNotifications": "Totale notifiche",
  "admin.triggerCheck": "Verifica ora",
  "admin.triggerCheckDesc": "Verifica manualmente le richieste escalate e invia notifiche",
  "admin.triggerCheckFailed": "Verifica di escalation fallita",
  "admin.triggerCheckSuccess": "Verifica di escalation completata",
  "admin.uploadDefaultImage": "Carica immagine",
  "admin.vatId": "Partita IVA",
  "admin.website": "Sito web",
  "auth.companyGroup": "Gruppo aziendale",
  "auth.selectCompanyGroup": "Seleziona il tuo gruppo...",
  "auth.selectSite": "Seleziona il tuo stabilimento...",
  "auth.site": "Stabilimento / Sito",
  "bulk.browse": "Sfoglia file",
  "bulk.col.article_number": "No. articolo",
  "bulk.col.manufacturer_name": "Produttore",
  "bulk.col.manufacturer_part_number": "Numero di parte",
  "bulk.col.notes_internal": "Note",
  "bulk.col.number_of_rolls": "Rotoli",
  "bulk.col.quantity": "Quantita",
  "bulk.col.uom": "UdM",
  "bulk.created": "Creati",
  "bulk.downloadTemplate": "Scarica modello",
  "bulk.dropHint": "Trascina e rilascia il tuo file Excel/CSV qui",
  "bulk.duplicates": "Esistente (Aggiornamento)",
  "bulk.enriched": "Arricchiti",
  "bulk.errors": "Errori",
  "bulk.executeImport": "Importa {{count}} righe",
  "bulk.importComplete": "Importazione completata!",
  "bulk.importError": "Importazione fallita",
  "bulk.importMode": "Modalita di importazione per duplicati",
  "bulk.importMore": "Importa altro",
  "bulk.importing": "Importazione in corso...",
  "bulk.invalidFile": "Formato file non valido. Usa .xlsx, .xls o .csv",
  "bulk.modeEnrich": "Arricchisci",
  "bulk.modeEnrichDesc": "Riempi solo campi vuoti, mantieni esistenti",
  "bulk.modeOverwrite": "Sovrascrivi",
  "bulk.modeOverwriteDesc": "Sostituisci tutti i campi con i valori importati",
  "bulk.moreRows": "altre righe",
  "bulk.newItems": "Nuovi articoli",
  "bulk.parseError": "Errore nell'analisi del file",
  "bulk.rejected": "Rifiutati",
  "bulk.rowError": "Riga {{row}}",
  "bulk.rows": "Righe",
  "bulk.rowsLoaded": "{{count}} righe caricate",
  "bulk.subtitle": "Importa piu materiali alla volta via Excel/CSV",
  "bulk.templateDownloaded": "Modello scaricato",
  "bulk.templateError": "Errore nel download del modello",
  "bulk.title": "Caricamento in massa",
  "bulk.updated": "Aggiornati",
  "bulk.valid": "Valido",
  "bulk.validate": "Valida dati",
  "bulk.validateError": "Validazione fallita",
  "bulk.validating": "Validazione in corso...",
  "bulk.validationErrors": "Errori di validazione",
  "common.deleting": "Eliminazione...",
  "create.addDocument": "Aggiungi documento PDF",
  "create.techSpec": "Scheda tecnica",
  "create.techSpecHint": "È richiesta almeno una scheda tecnica (PDF). Gli acquirenti ne hanno bisogno per valutare il materiale.",
  "create.techSpecRequired": "Obbligatorio",
  "create.addTechSpec": "Carica scheda tecnica (PDF)",
  "create.techSpecRequiredError": "Carica una scheda tecnica (PDF) prima di salvare.",
  "create.addPhoto": "Foto",
  "create.documents": "Documenti (PDF)",
  "create.erpArticleNumber": "Numero articolo ERP",
  "create.materialIndex": "Indice materiale",
  "create.photos": "Foto",
  "dashboard.agingAutoCalculated": "L'invecchiamento viene calcolato automaticamente dalla data di produzione",
  "dashboard.categoryBreakdown": "Suddivisione per categoria",
  "dashboard.categoryBreakdownDesc": "Principali categorie per valore a rischio",
  "dashboard.items": "Articoli",
  "dashboard.kEUR": "kEUR",
  "dashboard.skus": "SKU",
  "dashboard.topRisk": "Materiali a rischio piu alto",
  "dashboard.topRiskDesc": "Materiali di valore piu alto (rotazione lenta/nulla)",
  "dashboard.totalValue": "Valore totale dell'inventario",
  "dashboard.totalValueDesc": "Valore contabile totale di tutti gli SKU attivi",
  "dashboard.valueAtRisk": "Valore a rischio",
  "dashboard.valueAtRiskDesc": "Valore contabile dello stock a rotazione lenta/nulla",
  "ext.alreadyRegistered": "Gia registrato?",
  "ext.backStep": "Indietro",
  "ext.chooseRegistrationType": "Come desideri registrarti?",
  "ext.companyInfo": "Dati aziendali",
  "ext.confirmPassword": "Conferma password",
  "ext.continue": "Continua",
  "ext.createFirstListing": "Pubblica il primo materiale",
  "ext.createListing": "Pubblica materiale",
  "ext.deleteConfirmDesc": "Sei sicuro di voler eliminare questo materiale? L'azione non puo essere annullata.",
  "ext.deleteConfirmTitle": "Eliminare il materiale?",
  "ext.fillRequired": "Compila tutti i campi obbligatori",
  "ext.groupName": "Nome del gruppo",
  "ext.internalUser": "Utente interno?",
  "ext.linkedUsers": "Utenti collegati",
  "ext.materialDeleted": "Materiale eliminato",
  "ext.myCompany": "La mia azienda",
  "ext.myListings": "I miei annunci",
  "ext.nextStep": "Avanti: Account utente",
  "ext.noCompanyLinked": "Nessuna azienda esterna collegata al tuo account",
  "ext.noLinkedUsers": "Nessun utente collegato",
  "ext.noListings": "Nessun materiale pubblicato",
  "ext.noListingsDesc": "Pubblica il tuo primo materiale per offrirlo sul mercato.",
  "ext.passwordMismatch": "Le password non corrispondono",
  "ext.passwordTooShort": "La password deve avere almeno 6 caratteri",
  "ext.pendingMessage": "La tua registrazione e in fase di revisione. Una volta approvata, potrai offrire materiali sul mercato.",
  "ext.pendingTitle": "Approvazione in attesa",
  "ext.portalTitle": "Portale aziendale",
  "ext.registerAsExternal": "Registrati come azienda esterna",
  "ext.registerAsGroup": "Come gruppo",
  "ext.registerAsGroupDesc": "Azienda con piu stabilimenti/sedi",
  "ext.registerAsSite": "Come sito singolo",
  "ext.registerAsSiteDesc": "Sede singola senza gruppo padre",
  "ext.registerDesc": "Registra la tua azienda per offrire materiali sul mercato.",
  "ext.registerGroupDesc": "Registra il tuo gruppo per partecipare al mercato con piu siti.",
  "ext.registerInternal": "Registrati qui",
  "ext.registerSiteDesc": "Registra il tuo sito come sede singola sul mercato.",
  "ext.registerTitle": "Registrati come azienda esterna",
  "ext.registrationPending": "La tua azienda e in fase di revisione. Riceverai una notifica quando il tuo accesso sara attivato.",
  "ext.registrationSuccess": "Registrazione completata!",
  "ext.registrationType": "Tipo",
  "ext.rejectedMessage": "Purtroppo la tua registrazione e stata rifiutata. Contatta il supporto per maggiori informazioni.",
  "ext.rejectedTitle": "Registrazione rifiutata",
  "ext.siteName": "Nome del sito",
  "ext.submitRegistration": "Invia registrazione",
  "ext.userAccount": "Account utente",
  "filter.advancedFilters": "Filtri avanzati",
  "filter.ageBucket": "Eta dello stock",
  "filter.age_0_90": "< 3 mesi",
  "filter.age_181_360": "6-12 mesi",
  "filter.age_91_180": "3-6 mesi",
  "filter.age_gt_360": "> 12 mesi",
  "filter.basicFilters": "Filtri",
  "filter.both": "Entrambi",
  "filter.certifications": "Certificazioni",
  "filter.clearAll": "Cancella tutto",
  "filter.clearAllFilters": "Cancella tutti i filtri",
  "filter.clearFilters": "Cancella filtri",
  "filter.complianceFlag": "Indicatore di conformita",
  "filter.compliant": "Conforme",
  "filter.core": "Nucleo",
  "filter.coreDiameter": "Diametro del nucleo",
  "filter.customerSpecific": "Specifico per il cliente",
  "filter.filters": "Filtri",
  "filter.materialProperties": "Proprieta del materiale",
  "filter.max": "Max",
  "filter.min": "Min",
  "filter.minQuantity": "Quantita minima",
  "filter.no": "No",
  "filter.qty": "Qta",
  "filter.quantity": "Quantita",
  "filter.stockDetails": "Dettagli stock",
  "filter.technicalSpecs": "Specifiche tecniche",
  "filter.thickness": "Spessore",
  "filter.thicknessRange": "Intervallo spessore",
  "filter.widthRange": "Intervallo larghezza",
  "filter.yes": "Si",
  "group.allSites": "Tutti i siti",
  "group.filterSite": "Filtra per sito",
  "group.filterStatus": "Filtra per stato",
  "group.noMaterials": "Nessun materiale trovato nel tuo gruppo",
  "group.otherSite": "Altro sito",
  "group.ownMaterial": "Materiale proprio",
  "group.sites": "Siti",
  "group.skuCount": "{{count}} SKU",
  "group.subtitle": "Tutti i materiali su tutti i siti del tuo gruppo aziendale",
  "group.title": "Materiali del mio gruppo",
  "group.totalValue": "Valore totale",
  "masterData.applied": "Dati anagrafici applicati",
  "masterData.appliedLabel": "Dati anagrafici applicati",
  "masterData.matchesFound": "Dati anagrafici trovati",
  "masterData.searchPlaceholder": "Cerca per fornitore, no. articolo...",
  "myMaterials.allStatuses": "Tutti gli stati",
  "myMaterials.archive": "Archivia",
  "myMaterials.archiveDesc": "Il materiale verra archiviato e non sara piu visibile sul mercato.",
  "myMaterials.archiveTitle": "Archiviare il materiale?",
  "myMaterials.archived": "Materiale archiviato",
  "myMaterials.articles": "articoli",
  "myMaterials.bulkUpload": "Caricamento in massa",
  "myMaterials.deleteDesc": "Il materiale e tutto l'inventario associato verranno eliminati permanentemente.",
  "myMaterials.deleteTitle": "Eliminare il materiale?",
  "myMaterials.deleted": "Materiale eliminato",
  "myMaterials.empty": "Nessun articolo trovato",
  "myMaterials.emptyDesc": "Nessun articolo e stato ancora pubblicato nel tuo sito.",
  "myMaterials.newArticle": "Nuovo articolo",
  "myMaterials.noSite": "Il tuo account non ha un sito assegnato.",
  "myMaterials.noSiteDesc": "Contatta un amministratore per essere assegnato a un sito.",
  "myMaterials.noSiteTitle": "Nessun sito assegnato",
  "myMaterials.quantity": "Qta",
  "myMaterials.searchPlaceholder": "Cerca articoli...",
  "myMaterials.statusArchived": "Archiviato",
  "myMaterials.title": "I miei materiali del sito",
  "myMaterials.value": "Valore",
  "myMaterials.you": "Tu",
  "nav.myGroup": "Il mio gruppo",
  "nav.myMaterials": "I miei articoli",
  "nav.scenario": "Scenario",
  "pagination.next": "Successivo",
  "pagination.previous": "Precedente",
  "preset.applied": "Preimpostazione \"{name}\" applicata",
  "preset.applyFailed": "Errore nell'applicazione della preimpostazione",
  "preset.delete": "Elimina",
  "preset.deleteConfirm": "Eliminare la preimpostazione?",
  "preset.deleteDescription": "La preimpostazione \"{name}\" verra eliminata permanentemente.",
  "preset.deleteFailed": "Errore nell'eliminazione della preimpostazione",
  "preset.deleted": "Preimpostazione eliminata",
  "preset.filters": "filtri",
  "preset.filtersWillBeSaved": "filtri verranno salvati",
  "preset.maxReached": "Massimo raggiunto",
  "preset.name": "Nome della preimpostazione",
  "preset.namePlaceholder": "es. Film FSC > 100mm",
  "preset.nameRequired": "Inserisci un nome per la preimpostazione",
  "preset.newName": "Nuovo nome",
  "preset.noFiltersToSave": "Nessun filtro attivo da salvare",
  "preset.noPresets": "Nessuna preimpostazione salvata",
  "preset.presets": "Preimpostazioni",
  "preset.rename": "Rinomina",
  "preset.renameFailed": "Errore nel rinominare la preimpostazione",
  "preset.renamePreset": "Rinomina preimpostazione",
  "preset.renamed": "Preimpostazione rinominata",
  "preset.saveCurrentFilters": "Salva i filtri attuali",
  "preset.saveDescription": "Dai un nome alla tua combinazione di filtri per applicarla rapidamente in seguito.",
  "preset.saveFailed": "Errore nel salvataggio della preimpostazione",
  "preset.saveHint": "Applica i filtri e salvali",
  "preset.savePreset": "Salva preimpostazione filtro",
  "preset.saved": "Preimpostazione salvata",
  "preset.used": "preimpostazioni utilizzate",
  "scenario.applyChanges": "Applica modifiche",
  "scenario.autoApproved": "Auto-approvato",
  "scenario.blocked": "Bloccato",
  "scenario.currentSettings": "Impostazioni attuali",
  "scenario.docsBlocked": "Docs bloccati",
  "scenario.enabled": "Abilitato",
  "scenario.escalatedRequests": "Richieste escalate",
  "scenario.externalAccess": "Accesso esterno",
  "scenario.internalWindow": "Nella finestra interna",
  "scenario.itemsAtRisk": "Articoli a rischio",
  "scenario.noChanges": "Regola le impostazioni e clicca su 'Anteprima' per vedere l'effetto",
  "scenario.pendingRequests": "Richieste in attesa",
  "scenario.preview": "Anteprima impatto",
  "scenario.previewResult": "Impatto previsto",
  "scenario.subtitle": "Anteprima dell'impatto delle modifiche di governance prima dell'applicazione",
  "scenario.title": "Analisi What-If degli scenari",
  "scenario.valueAtRisk": "Valore a rischio",
  "scenario.whatIf": "Anteprima What-If",
  "search.allMaterials": "Tutti i materiali",
  "search.filtering": "Filtraggio in corso...",
  "search.materialsFound": "materiali trovati",
  "search.resultsFor": "Risultati per",
  "search.tryAdjusting": "Prova a modificare i filtri o i termini di ricerca",
  "sort.newestFirst": "Piu recenti",
  "sort.oldestFirst": "Meno recenti",
  "sort.priceHighLow": "Prezzo: Decrescente",
  "sort.priceLowHigh": "Prezzo: Crescente",
  "sort.quantityHighLow": "Quantita: Decrescente",
  "sort.sortBy": "Ordina per",
  "status.archived": "Archiviato",
  "status.pendingApproval": "Approvazione in attesa",
  "admin.guideAuditSteps": ["Naviga su Admin > Registro di audit.", "Usa il filtro del tipo di entita.", "Usa il filtro dell'azione.", "Espandi le 'Modifiche' per vedere i dati modificati.", "Usa la paginazione per navigare lo storico."],
  "admin.guideCategoriesSteps": ["Naviga su Admin > Categorie per visualizzare l'albero.", "Clicca su 'Aggiungi categoria' per una categoria principale.", "Clicca su '+' su qualsiasi categoria per aggiungere una sottocategoria.", "Modifica o elimina le categorie esistenti con i pulsanti di azione.", "Le categorie possono essere riordinate tramite il campo di ordinamento."],
  "admin.guideDashboardSteps": ["Naviga alla Dashboard.", "Controlla i KPI globali.", "Usa il filtro del sito per metriche specifiche.", "Scarica i report PDF di sostenibilita.", "Monitora i materiali a rischio."],
  "admin.guideExternalSteps": ["Le aziende esterne si registrano tramite il modulo pubblico (/register-external).", "Naviga su Admin > Aziende esterne per esaminare le richieste.", "Clicca su 'Approva' per attivare l'azienda.", "Clicca su 'Rifiuta' per negare l'accesso.", "Le aziende approvate possono elencare i loro materiali.", "Clicca su una riga dell'azienda per vedere gli utenti collegati."],
  "admin.guideGettingStartedSteps": ["Crea il tuo gruppo aziendale e almeno un sito sotto Admin > Organizzazioni e Siti.", "Carica i dati iniziali con il pulsante 'Carica dati' (solo una volta per demo/test).", "Invita gli utenti condividendo il link di registrazione. Approva i nuovi utenti sotto Admin > Utenti.", "Configura la tua modalita di governance preferita sotto Admin > Scenari.", "Carica i materiali tramite la pagina di importazione o creali individualmente."],
  "admin.guideImportSteps": ["Naviga alla pagina di importazione.", "Scarica il modello Excel.", "Compila i tuoi dati e carica il file.", "Verifica i risultati della validazione.", "Scegli una modalita di importazione.", "Esegui l'importazione."],
  "admin.guideNotificationsSteps": ["Naviga su Admin > Notifiche.", "Controlla le statistiche: totale inviato, fallito e per tipo.", "Clicca su 'Verifica ora' per eseguire il controllo di escalation.", "Sfoglia lo storico delle notifiche.", "Le notifiche richiedono una chiave API Resend configurata."],
  "admin.guideScenariosSteps": ["Seleziona una modalita: Equilibrato (predefinito), Conservativo, Aggressivo (Cash) o Modalita Crisi.", "Regola la 'Finestra interna' (giorni in cui i materiali restano solo interni).", "Imposta i 'Giorni di escalation' per le notifiche automatiche.", "Attiva/disattiva 'Esterno abilitato' per controllare l'accesso esterno.", "Attiva/disattiva 'Approvazione richiesta' per l'approvazione automatica o manuale.", "Attiva 'Documentazione rigorosa' per bloccare gli articoli senza schede tecniche."],
  "admin.guideUsersSteps": ["Naviga su Admin > Utenti per vedere tutti i registrati.", "Gli utenti in attesa sono contrassegnati con un indicatore giallo.", "Clicca su 'Approva' per concedere l'accesso completo al mercato.", "Clicca su 'Revoca' per disattivare temporaneamente l'accesso.", "Gli amministratori vengono approvati automaticamente alla registrazione."],
  "admin.pendingRequests": "Richieste in attesa",
  "app.subtitle": "rendere utile il surplus",
  "auth.loginError": "E-mail o password non validi",
  "auth.loginSuccess": "Accesso effettuato!",
  "auth.passwordTooShort": "La password deve avere almeno 6 caratteri",
  "auth.passwordsNoMatch": "Le password non corrispondono",
  "auth.registerError": "Registrazione fallita",
  "filter.allCategories": "Tutte le categorie",
  "home.loginRequired": "Accedi per utilizzare la lista dei preferiti",
  "home.materialsCount": "materiali",
  "home.noMaterials": "Nessun materiale trovato.",
  "home.seedDescription": "Puoi caricare dati di esempio per iniziare.",
  "home.seedError": "Errore nel caricamento dei dati",
  "home.seedSuccess": "Dati caricati con successo! Aggiornamento...",
  "home.seeding": "Caricamento...",
  "home.watchlistError": "Errore nell'aggiornamento della lista dei preferiti",
  "sort.dateAdded": "Data di aggiunta",
  "sort.price": "Prezzo",
  "sort.quantity": "Quantita",
  "admin.platformSettings": "Impostazioni",
  "admin.resendEmail": "Reinvia email",
  "guide.title": "Aiuto & FAQ",
  "guide.subtitle": "Manuale utente e risposte alle domande frequenti",
  "guide.searchPlaceholder": "Cerca nel manuale e nelle FAQ...",
  "guide.tabGuide": "Manuale utente",
  "guide.tabFaq": "FAQ",
  "guide.noResults": "Nessun risultato per",
  "guide.topic": "argomento",
  "guide.topics": "argomenti",
  "home.hero.badge": "B2B Circolare · Stampa & Imballaggio",
  "home.hero.verified": "Verificato UE",
  "home.hero.headlineA": "Riutilizzare.",
  "home.hero.headlineB": "Riparare.",
  "home.hero.headlineC": "Ridistribuire.",
  "home.hero.subtitle": "Surplify è il marketplace B2B circolare per l'industria della stampa e dell'imballaggio — dà una seconda vita a materiali in eccedenza, ricambi e macchine usate. Ogni transazione evita la produzione vergine, risparmia CO₂ e preserva il capitale circolante.",
  "home.hero.impactPrefix": "Risparmiati insieme finora:",
  "home.hero.impactSuffix": "di CO₂",
  "home.hero.searchPlaceholder": "Produttore, codice articolo, materiale, modello…",
  "home.hero.searchBtn": "Cerca",
  "home.hero.verticalMaterials": "Eccedenza",
  "home.hero.verticalSpareParts": "Ricambi",
  "home.hero.verticalMachines": "Macchine",
  "home.hero.verticalPaints": "Inchiostri & rivestimenti",
  "home.hero.ctaPostWanted": "Pubblica una richiesta d'acquisto",
  "home.hero.ctaForSellers": "Per i venditori",
  "home.hero.ctaGuide": "Aiuto & guida",
  "home.hero.trustVies": "Partita IVA verificata da EU VIES",
  "home.hero.trustCompanies": "Account aziendali verificati",
  "home.hero.trustCircular": "Economia circolare",
  "home.newco.badge": "Nuovo su Surplify?",
  "home.newco.title": "La tua azienda sul marketplace B2B in 3 passi",
  "home.newco.subtitle": "Materiale in eccedenza, residui, vernici, ricambi e macchine da stampa usate — tutto su un'unica piattaforma. Inizia gratis, commercia in modo equo, documenta in conformità REACH/CLP.",
  "home.newco.step1Title": "Crea la tua azienda",
  "home.newco.step1Desc": "Ragione sociale, partita IVA, indirizzo — validato con VIES",
  "home.newco.step2Title": "Crea il tuo primo annuncio",
  "home.newco.step2Desc": "Materiale, vernice, ricambio o macchina — compila il modulo, fatto",
  "home.newco.step3Title": "Ricevi richieste e vendi",
  "home.newco.step3Desc": "Commissione solo in caso di transazione riuscita. Nessun costo di attivazione.",
  "home.newco.ctaRegister": "Registra ora la tua azienda",
  "home.newco.ctaPartners": "Per partner e grandi clienti",
  "home.newco.disclaimer": "Piano iniziale gratuito · Nessuna carta di credito richiesta · Conforme GDPR e B2B",
  "home.newco.whatYouGet": "Cosa ottieni",
  "home.newco.freeTier": "Con il piano iniziale gratuito",
  "home.newco.feat1Label": "4 verticali di materiale",
  "home.newco.feat1Sub": "Materiali · Vernici · Ricambi · Macchine",
  "home.newco.feat2Label": "Annunci illimitati",
  "home.newco.feat2Sub": "Nessun limite di quantità sul piano standard",
  "home.newco.feat3Label": "Algoritmo di matching",
  "home.newco.feat3Sub": "Le richieste degli acquirenti vengono abbinate automaticamente",
  "home.newco.feat4Label": "Conformità REACH/CLP",
  "home.newco.feat4Sub": "Schede di sicurezza e pittogrammi GHS integrati",
  "home.newco.feat5Label": "Reporting di sostenibilità",
  "home.newco.feat5Sub": "I risparmi di CO₂ vengono documentati automaticamente",
  "home.newco.freeBadge": "Inizia 100% gratis",
  "home.pillar.materials.label": "Eccedenza",
  "home.pillar.materials.title": "Eccedenze & materiali",
  "home.pillar.materials.desc": "Film, carta, bobine e semilavorati — mantenuti nel ciclo invece di essere inceneriti.",
  "home.pillar.materials.metric": "annunci attivi",
  "home.pillar.spareParts.label": "Ricambi",
  "home.pillar.spareParts.title": "Ricambi & moduli",
  "home.pillar.spareParts.desc": "Ricambi OEM riutilizzati — ogni componente salvato evita nuova estrazione e produzione.",
  "home.pillar.spareParts.metric": "nuovi",
  "home.pillar.machines.label": "Macchine",
  "home.pillar.machines.title": "Macchine da stampa",
  "home.pillar.machines.desc": "Le presse usate sostituiscono quelle nuove — fino all'80 % di CO₂ in meno.",
  "home.pillar.machines.metric": "disponibili",
  "home.pillar.paints.label": "Inchiostri & rivestimenti",
  "home.pillar.paints.title": "Inchiostri, vernici & additivi",
  "home.pillar.paints.desc": "Inchiostri, vernici e additivi chimici in eccedenza — mantenuti in produzione invece di essere smaltiti come rifiuti pericolosi.",
  "home.pillar.paints.metric": "in stock",
  "home.sustain.liveImpact": "Impatto in tempo reale",
  "home.sustain.co2": "CO₂ risparmiato",
  "home.sustain.redistributed": "ridistribuito",
  "home.sustain.sites": "sedi",
  "home.sustain.circular": "tasso circolare",
  "home.sustain.atRisk": "a rischio",
  "home.machines.label": "Vertical · Macchine",
  "home.machines.title": "Macchine da stampa usate, per un secondo ciclo produttivo.",
  "home.machines.subtitle": "Ogni macchina usata sostituisce una nuova — con una frazione di CO₂ e materie prime. Ispezione opzionale, compatibilità verificata.",
  "home.machines.seeAll": "Tutte le macchine",
  "home.machines.emptyDesc": "Nessuna macchina da stampa pubblicata al momento.",
  "home.machines.emptyCreate": "Crea annuncio",
  "home.spareParts.label": "Vertical · Ricambi",
  "home.spareParts.title": "Ricambi OEM — mantenuti in circolazione.",
  "home.spareParts.subtitle": "Stock inutilizzato, buffer di obsolescenza, linee dismesse. Reindirizziamo i ricambi alla produzione invece che alla rottamazione.",
  "home.spareParts.seeAll": "Tutti i ricambi",
  "home.spareParts.emptyDesc": "Nessun ricambio pubblicato al momento.",
  "home.spareParts.emptyCreate": "Crea il primo annuncio",
  "home.paints.label": "Vertical · Inchiostri & rivestimenti",
  "home.paints.title": "Inchiostri, vernici e additivi in eccedenza — di nuovo nella macchina.",
  "home.paints.subtitle": "Tonalità dismesse, partite residue, stock ritirati. Riportiamo i prodotti chimici di stampa in produzione invece di pagare costi di smaltimento.",
  "home.paints.seeAll": "Tutti gli inchiostri & rivestimenti",
  "home.paints.emptyDesc": "Nessun inchiostro, vernice o additivo pubblicato al momento.",
  "home.paints.emptyCreate": "Crea il primo annuncio",
  "home.materials.label": "Vertical · Eccedenza",
  "home.materials.title": "Eccedenza & sovrapproduzione.",
  "home.materials.subtitle": "Stock dal vivo da produzioni, svuotamenti di magazzino e resi qualità — reintrodotto direttamente nell'industria.",
  "home.trust.vies.title": "IVA UE VIES",
  "home.trust.vies.desc": "Verifica automatica delle partite IVA per ogni azienda registrata.",
  "home.trust.companies.title": "Aziende verificate",
  "home.trust.companies.desc": "Solo gli account B2B verificati ottengono accesso completo al marketplace.",
  "home.trust.csv.title": "Importazione CSV in blocco",
  "home.trust.csv.desc": "Pubblica migliaia di ricambi e materiali in un solo caricamento.",
  "home.trust.circular.title": "Economia circolare",
  "home.trust.circular.desc": "Ogni ridistribuzione evita produzione vergine e riduce le emissioni scope 3.",
  "machine.card.label": "Macchina da stampa",
  "machine.card.year": "Anno",
  "machine.card.hours": "h",
  "machine.card.width": "Larghezza",
  "machine.card.price": "Prezzo",
  "sparePart.card.label": "Ricambio",
  "sparePart.card.compatible": "Compatibile:",
  "sparePart.card.single": "Articolo singolo"
};

export default it;
